export const preload = (image, type = 'small') => {
  new Image().src = image[type];
  if (type !== 'hd') {
    preload(image, type === 'small' ? 'medium' : 'hd');
  }
};
